import { FullTask } from "../types/FullTask";

export function getGroupByLocation(task: FullTask, groupBy: string) {
  switch (groupBy) {
    case "hfbPickup": {
      return task.pickup_location || task.pickup_location_custom || "";
    }
    case "hfbRefill": {
      return task.location_custom || task.location || "";
    }
    default: {
      return "";
    }
  }
}
